import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CatTableHeader } from '@blocks-react/components/TableHeader';
import { CatTableRow } from '@blocks-react/components/TableRow';
import { CatTableHeaderCell } from '@blocks-react/components/TableHeaderCell';
import { savedListTableSchema } from '../../declarations.propTypes';
import ListTypeHeader from '../ListTypeHeader';
import { FIRST_PAGE, SAVED_LIST_COLUMN_IDS } from '../../constants';

const SavedListTableHeader = ({ schema, handleSort, onPageChange }) => {
  const { t } = useTranslation();
  const isCSPCustomer = useSelector(state => state?.common?.isCSPCustomer);

  return (
    <CatTableHeader>
      <CatTableRow>
        {schema.map(item => (
          <CatTableHeaderCell
            behavior={item.behavior}
            onBlColumnSort={({ detail }) => {
              handleSort({
                sortBy: item.id,
                sortType: item.sortType,
                sortDirection: detail.value
              });
              onPageChange(FIRST_PAGE);
            }}
            key={item.id}
            width={item.width}
            align={item.align}
          >
            <div className="d-flex align-items-center justify-content-between">
              {t(item.label)}
              {isCSPCustomer && item.id === SAVED_LIST_COLUMN_IDS.LIST_TYPE && (
                <ListTypeHeader />
              )}
            </div>
          </CatTableHeaderCell>
        ))}
      </CatTableRow>
    </CatTableHeader>
  );
};

export default SavedListTableHeader;

SavedListTableHeader.propTypes = {
  schema: savedListTableSchema,
  handleSort: PropTypes.func,
  onPageChange: PropTypes.func
};
